import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import noDocuments from '../../../assets/img/nodocfound.png';
import CreateIcon from '@material-ui/icons/Create';

const useRowStyles = makeStyles({
    root:
    {
        '& > *': {
            borderRight: '1px solid lightgray',
            borderLeft: '1px solid lightgray',
            borderTop: '1px solid lightgray'
        },
        borderRight: '1px solid lightgray',
        borderBottom: '1px solid lightgray',
        cursor: 'pointer',

    },
    header: {
      
        paddingTop: '9px',
        paddingBottom: '9px'

    },
    title:
    {
        fontFamily: 'Montserrat',
        fontWeight: '600',
        color: '#DC251A',
        fontSize: '12px'
    },
    description:
    {
        fontFamily: 'Montserrat',
        fontWeight: 500,
        fontSize: '12px',
        color: '#313131',
    }
});

function createData(documentTitle, typology, dateOfWriting, author, language) {
    return {
        documentTitle,
        typology,
        dateOfWriting,
        author,
        language,
    };
}

function Row(props) {
    const { row, data } = props;
    const [open, setOpen] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false)
    const [manuscript, setManuscript] = React.useState({})
    const classes = useRowStyles();

    
    const handleEdit = (data) => {
        setManuscript(data)
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
    }

    return (
        <React.Fragment>
            <TableRow className={classes.root}  style={data.id % 2 ? { background: "#F2F2F2" } : { background: "white" }}>
            
                <TableCell onClick={() => setOpen(!open)} style={{ fontFamily: 'Montserrat', color: '#333333', fontWeight: '600', borderLeft:  '1px solid white', borderBottom: '1px solid white', fontSize: '14px' }}  >
                    {row.documentTitle}
                </TableCell>
                <TableCell onClick={() => setOpen(!open)} style={{ fontFamily: 'Montserrat', color: '#333333', fontWeight: '600', borderLeft:  '1px solid white', borderBottom: '1px solid white', fontSize: '14px' }} align="left">{row.typology}</TableCell>
                <TableCell onClick={() => setOpen(!open)} style={{ fontFamily: 'Montserrat', color: '#333333', fontWeight: '600', borderLeft:  '1px solid white', borderBottom: '1px solid white', fontSize: '14px' }} align="left">{row.dateOfWriting}</TableCell>
                <TableCell onClick={() => setOpen(!open)} style={{ fontFamily: 'Montserrat', color: '#333333', fontWeight: '600', borderLeft:  '1px solid white', borderBottom: '1px solid white', fontSize: '14px' }} align="left">{row.author}</TableCell>
                <TableCell onClick={() => setOpen(!open)} style={{ fontFamily: 'Montserrat', color: '#333333', fontWeight: '600', borderRight:  '1px solid white', borderBottom: '1px solid white', fontSize: '14px' }} align="left">{row.language}</TableCell>
            </TableRow>

            <TableRow key={data.id} >
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: 'white', borderRight: '1px solid white', borderLeft: '1px solid white', borderBottom: '1px solid white' }}  colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Paper elevation={12} style={{ marginLeft: '-16px', marginRight: '-16px', marginTop: '-5px', marginBottom: '-25px' }} >
                            <Grid container style={{ marginTop: '10px', marginLeft: '15px' }}>
                                <Grid item lg={6} >
                                    <p className={classes.title} style={{ marginLeft: '10px', marginTop: '30px' }}>SUMMARY </p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '92%', height: '70px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px',  marginTop: '0px'  }}>{data.summary}</p>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid container style={{ marginTop: '0px', marginLeft: '15px', marginBottom: '30px' }}>
                                <Grid item lg={2} style={{ marginBottom: '30px' }} >
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>RECIPIENT </p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '160px', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px' }}>{data.recipient}</p>
                                    </Box>

                                </Grid>
                                <Grid item lg={2} >
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>PLACE: START POINT</p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '160px', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px' }}>{data.startPoint}</p>
                                    </Box>
                                </Grid>

                                <Grid item lg={2} >
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>PLACE: END POINT </p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '160px', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px' }}>{data.endPoint} </p>
                                    </Box>

                                </Grid>
                                <Grid item lg={2} >
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>ARCHIVE/LIBRARY</p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '160px', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px' }}>{data.archive}</p>
                                    </Box>
                                </Grid>

                                <Grid item lg={2} >
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>LINK </p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px', wordWrap: 'break-word' }}>{data.link}</p>
                                    </Box>
                                </Grid>
                                <Grid item lg={2} style={{ marginRight: '-6px', marginBottom: '25px' }}>
                                    <p className={classes.title} style={{ marginLeft: '10px' }}>RELATED DOCS</p>
                                    <Box margin={1} style={{
                                        backgroundColor: '#F2F2F2', width: '150px', height: '40px', overflow: "hidden",
                                        overflowY: "scroll", wordWrap: 'break-word', marginTop: '-5px'
                                    }} >
                                        <p className={classes.description} style={{ padding: '5px', marginTop: '0px' }}>{data.relatedDocuments}</p>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

const renderRows = (data, cb, cd) => {
    return data.map(item => (
        <Row key={item.id}
            data={item}
            row={createData(item.documentTitle, item.typology, item.dateOfWriting, item.author, item.language)}
        />
    )
    )
}



export default function ManuscriptTable({ manuscripts }) {
    const classes = useRowStyles();

    return (
        manuscripts.length ? //If there is no data, an image will be displayed.
            <TableContainer component={Paper} elevation="0" style={{ marginBottom: '100px' }}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.header} width={400} style={{ fontFamily: 'Montserrat', color: '#DC251A', fontWeight: '600', borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '14px', backgroundColor: 'white' }}>DOCUMENT TITLE</TableCell>
                            <TableCell className={classes.header} style={{ fontFamily: 'Montserrat', color: '#DC251A', fontWeight: '600', borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '14px', backgroundColor: 'white' }} align="left">TYPOLOGY</TableCell>
                            <TableCell className={classes.header} style={{ fontFamily: 'Montserrat', color: '#DC251A', fontWeight: '600', borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '14px', backgroundColor: 'white' }} align="left">DATE OF WRITING</TableCell>
                            <TableCell className={classes.header} style={{ fontFamily: 'Montserrat', color: '#DC251A', fontWeight: '600', borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '14px', backgroundColor: 'white' }} align="left">AUTHOR/SENDER</TableCell>
                            <TableCell className={classes.header} style={{ fontFamily: 'Montserrat', color: '#DC251A', fontWeight: '600', borderRight: '1px solid lightgray', borderLeft: '1px solid lightgray', borderTop: '1px solid lightgray', fontSize: '14px', backgroundColor: 'white' }} align="left">LANGUAGE</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderRows(manuscripts)}
                    </TableBody>

                </Table>
            </TableContainer> :
            <div style={{ background: 'white', paddingTop: '60px', paddingBottom: '60px', marginTop: '0px' }}>
                <img style={{
                    width: "400px", display: 'block',
                    margin: '0 auto'
                }} src={noDocuments} />
            </div>
    );
}